import { render, staticRenderFns } from "./mt5ApplyForm.vue?vue&type=template&id=54afc27d&scoped=true&"
import script from "./mt5ApplyForm.vue?vue&type=script&lang=js&"
export * from "./mt5ApplyForm.vue?vue&type=script&lang=js&"
import style0 from "./mt5ApplyForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./mt5ApplyForm.vue?vue&type=style&index=1&id=54afc27d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54afc27d",
  null
  
)

component.options.__file = "mt5ApplyForm.vue"
export default component.exports